const GoToPrice = () => {
  return (
    <>
      <div className="go-to-price-container">
        <p style={{fontSize: "1.1rem"}}>
         <strong> A csomaghoz tartozó ár megtekinthető <a href="/orvosdiagnosztika/araink">itt</a>.</strong>
        </p>
      </div>
    </>
  );
};

export default GoToPrice;
